import { useState, useEffect, useRef, } from "react";
import { useStripe, useElements , CardElement} from "@stripe/react-stripe-js";
import axios from 'axios';

function Test() {
    useEffect(()=>{
        fetch("https://payment-pqnu.onrender.com/create-checkout-session", {
            method: "POST"
          })
            .then(res => {
              if (res.ok) return res.json()
              return res.json().then(json => Promise.reject(json))
            })
            .then(({ url }) => {
              window.location = url
            })
            .catch(e => {
              console.error(e.error)
            })
    },[])
    
  
    return (
     <h1>Test</h1>
    )
  }
  
  export default Test;